/* eslint-disable no-useless-computed-key */
/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from 'react'; // we need this to make JSX compile
import { Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'
import { Logger } from '../../../../libs/utils/logger';
import HttpClient from '../../../../libs/utils/httpClient';
import { IFileInfo } from '../../../Data/FxAgreementLinkCard';
import { deleteUnwantedRequest, getBase64FromPDF, getLastFourDigits, kycSignupFormValidator, sortByAuthSignatoryFirst } from '../../../Utils/CommonBaseClass';
import { ReviewAndSubmitSignup } from '../Common/ReviewAndSubmitSignup';
import { ICardData } from '../Common/ReviewInfoCard';
import { BusinessDetailsSignup } from './BusinessDetailsSignup';
import { BusinessLeftBarSignup } from './BusinessLeftBarSignup';
import { getCustomerUrl, processAPIResponse, pushGTM, setFullStoryEvents, useIsMobileOrTabletScreen } from '../../../../libs/utils/utils';
import { getKey, removeCookieCustom, setKey } from '../../../../libs/utils/storageManager';
import { BusinessOwnerCard } from './BusinessOwner/BusinessOwnerCard';
import { RegisterComponent } from '../../../../libs/saga/dataSaga';
import { convertToPhoneDisplayFormat, clean, updateComponentData, fetchDataFromState, updateComponentParams, callAPI, Method} from '../../../Utils/CommonBaseClass';
import FxSnackBar from '../../../Utils/fx-snack-bar';
import { useDispatch, useSelector } from 'react-redux';
import { setLocalStorage } from '../../../../libs/utils/cacheHandler';
import { SignUpIndividualDetailsRef } from '../Individual/SignUpIndividualDetails';
import { getAutosavedDataFromOnboardingFormDataApi, unflattenObject, updateOnboardingFormData } from '../../../../libs/utils/autoSaveField';
import { getCustomerData, getLocationDetailData } from './businessApi';
import { mergeAutosaveWithApi, prepareBusinessOwnerRequest } from '../../../../libs/utils/businessDataUtils';
const httpClient = HttpClient.getClient();

Logger.debug("BusinessUserSignup.tsx", "Business User Signup initializing")

/**
 * Component: BusinessUserSignup
 */
export const BusinessUserSignup: React.FC<any> = React.memo(
    (props) => {
        const history = useHistory()
        const dispatch = useDispatch();
        let context : any;
        ({ context, props } = RegisterComponent(props));
        const { mainMenu, isLoading, paymentIdDetailReq, initialUserData, initialBOData, isUpdateContactRequest, formReq, locationDetailReq  } = props;
        const businessDetailsSignupForm = useRef<SignUpIndividualDetailsRef>(null);
        const businessOwnerCardForm = useRef<SignUpIndividualDetailsRef>(null);
        const [hasFetchedOnboardingData, setHasFetchedOnboardingData] = useState(false);
        const [validForms,setValidForms] = useState({
            "businessDetailsSignupForm":true,
            "businessOwnerCardForm":true
        })
        const [btnDisabled, setBtnDisabled] = useState(true);

        // Selector with proper abstraction
        const useBusinessState = () => {
            return useSelector((state: any) => {
                return fetchDataFromState(state, 'customer-kyc-data');
            });
        };

        /**
         * This method fetches the latest AutoSavedData & the Latest BeneficialOwnerData coming from the API
         * and merges them and prepares it to send to the child components
         * @param autoSavedData 
         * @returns 
         */
        const useBusinessOwnerComponentData = (autoSavedData: any[]) => {
            const businessState = useBusinessState();
            const ownerData = businessState?.data?.beneficialOwnerData || [];
            const mergedData = mergeAutosaveWithApi(
                    autoSavedData ?? [],
                    ownerData
                  );
            return useMemo(() => {
                return mergedData;
            }, [autoSavedData, ownerData]);
        };


        // Usage inside your component
        const businessState = useBusinessState();
        const businessOwnerComponentData = useBusinessOwnerComponentData(props?.autoSavedData);

        /**
         * This method handles the delete operation action on the BO
         * and then updates the autoSavedData prop and the Application state of the beneficialOwnerData
         * @param index 
         * @param data 
         */
        const handleDeleteBOOperations = async (index: number, data: any) => {
            const beneficialOwnerReq = businessState?.data?.beneficialOwnerReq || [];
            const beneficialOwnerData = businessState?.data?.beneficialOwnerData || [];
            // Remove the item at the given index from req array
            const updatedReqArray = [...beneficialOwnerReq];
            updatedReqArray.splice(index, 1);
            // Remove the beneficial owner data at the given index
            const updatedBeneficialOwners = beneficialOwnerData.filter((_: any, i: any) => i !== index);
            // Prepare delete request for backend
            const deleteRequest = {
                deleteNode: `business.beneficialOwner[${index}]`,
            };
            // Delete node from autosave
            await updateOnboardingFormData(deleteRequest);
            // Fetch previously saved data from onboarding API
            const previouslySavedData = await getAutosavedDataFromOnboardingFormDataApi();
            // Fetch current saved business owner data from API
            const customerBusinessData = await getCustomerData();
            const detailedBusinessInfo = customerBusinessData?.data?.business;
            // Format new beneficial owner data from API response
            const newCustomerData = getBODetailsDataFromApi(
                detailedBusinessInfo?.beneficialOwner || []
            );
            if (previouslySavedData?.data?.flatFields) {
                // Unflatten autosaved data into nested object
                const objectFormatData: any = unflattenObject(previouslySavedData.data.flatFields);
                // Format autosaved beneficial owner data
                const formattedData = getBODetailsDataFromApi(
                objectFormatData?.business?.beneficialOwner,
                'autoSavedData'
                );
                // **Normalize authSignatory: ensure only one true**
                let authSignatoryFound = false;
                const normalizedBeneficialOwners = updatedBeneficialOwners.map((owner: any) => {
                if (owner.authSignatory && !authSignatoryFound) {
                    authSignatoryFound = true;
                    return owner; // keep first true
                }
                return { ...owner, authSignatory: false };
                });
                // Rebuild request and data arrays based on normalized owners
                const dataArray: any[] = [];
                const reqArray1: any[] = [];
                for (const item of normalizedBeneficialOwners) {
                const result = await prepareBusinessOwnerRequest({ ...item });
                dataArray.push(result.data);
                reqArray1.push(result.req);
                }
                // Update redux/state data with rebuilt arrays
                const dataCopy = { ...businessState?.data };
                dataCopy.beneficialOwnerData = dataArray;
                dataCopy.beneficialOwnerReq = reqArray1;
                updateComponentData(dispatch, 'customer-kyc-data', { ...dataCopy });
                // Update component params with autosaved formatted data
                updateComponentParams(dispatch, props?.id, { autoSavedData: formattedData });
                handleSubmitButtonDisable(false)
            }
            };

        useEffect(() => {
            updateComponentParams(dispatch, props.id, { mainMenu: 1, isLoading: false, paymentIdDetailReq: undefined, initialUserData: false, initialBOData: false, isUpdateContactRequest: false, formReq: undefined, locationDetailReq: undefined, fetchIds: false    });
        },[dispatch,props.id])


        /**
         * This useEffect is used to call the GET Onboardding Data API
         */
        useEffect(() => {
            if (!hasFetchedOnboardingData && businessState?.data?.beneficialOwnerData?.length > 0) {
                setHasFetchedOnboardingData(true);
                fetchOnboardingFormData();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[businessState?.data?.beneficialOwnerData]);

        /**
         * This method fetches the previously saved data from the GET autoSaved API
         * and sets the values in the form fields
         */
        const fetchOnboardingFormData = async () => {
            // Call the autosave API to retrieve previously saved onboarding form data
            const response = await getAutosavedDataFromOnboardingFormDataApi();
            const flatFields = response?.data?.flatFields;

            // Exit early if no autosaved data is present
            if (!flatFields) return;

            // Convert flat field structure into nested object format
            const objectFormatData: any = unflattenObject(flatFields);

            // Extract and format beneficial owner data from autosaved data
            const autoSavedOwners = getBODetailsDataFromApi(objectFormatData.business?.beneficialOwner, 'autoSavedData');

            // Get the current API-loaded beneficial owner data from state
            const apiOwners = businessState?.data?.beneficialOwnerData ?? [];

            // Merge autosaved data with the API data for beneficial owners
            const mergedData = mergeAutosaveWithApi(autoSavedOwners ?? [], apiOwners);

            // Update component parameters (e.g. local state or context) with merged data
            updateComponentParams(dispatch, props?.id, { autoSavedData: mergedData });

            // Process all beneficial owners (e.g. for validation or display logic)
            if (Array.isArray(autoSavedOwners)) {
                processAllBeneficialOwners(mergedData);
            }

            // Prepare a copy of the current business data
            const businessCopy = { ...(businessState?.data ?? {}) };

            // If autosaved beneficial owner data is available, set it into businessCopy
            if (Array.isArray(objectFormatData?.business?.beneficialOwner) && objectFormatData.business.beneficialOwner.length > 0) {
                businessCopy.beneficialOwnerData = getBODetailsDataFromApi(objectFormatData.business.beneficialOwner);
            }

            // Update the Redux or component state with the updated business data
            updateComponentData(dispatch, 'customer-kyc-data', businessCopy);
        };



        /**
         * This method creates the component friendly formats of the 
         * BO data to save in the 'customer-kyc-data' state
         * @param ownerArray 
         */
        const processAllBeneficialOwners = async (ownerArray: any[]) => {
            const dataCopy = { ...(businessState?.data ?? {}) };

            // Prepare all requests concurrently
            const results = await Promise.all(
                ownerArray.map(item => prepareBusinessOwnerRequest({ ...item }))
            );

            // Separate the `data` and `req` fields from each result
            dataCopy.beneficialOwnerData = results.map(r => r.data);
            dataCopy.beneficialOwnerReq = results.map(r => r.req);

            // Update the state with processed beneficial owner data
            updateComponentData(dispatch, 'customer-kyc-data', dataCopy);
        };


        /**
         * This method basically calls the respective form submission apis
         * whenever the User tries to navigate thru the Left Panel
         * @param step 
         * @param currentPage 
         */
        const handleDataSaveOnSectionChange = async (step: any, currentPage: any) => {
            // Helper function to validate a form and update the key state
            const validateForm = async (formRef: any, keyName: string) => {
                const feedback = await formRef.current?.submitForm();
                if (feedback) {
                currentPage = feedback.step;
                setKey(keyName, feedback.success ? 'valid' : 'invalid');
                }
            };

            // Decide which form to validate based on the step
            switch (step) {
                case 1:
                await validateForm(businessDetailsSignupForm, 'businessDetailsSignupForm');
                break;
                case 2:
                callingGetCustomerApi(); // API call before validation
                await validateForm(businessOwnerCardForm, 'businessOwnerCardForm');
                break;
                default:
                // No action for other steps
                break;
            }
        };

 
        const isSmallScreen = useIsMobileOrTabletScreen();
        

        // Method handles the click event of the left menu
        const handleMenuClick = (main: any) => {
            updateComponentParams(dispatch, props.id, { mainMenu: main })
        }

        /**
         * Handles submission of the “Business Details” step:
         * 1. Updates in‐memory component state  
         * 2. Splits out address & DBA info into a separate “location” payload  
         * 3. POSTs business & location data to two APIs  
         * 4. Combines results, advances the menu on success, or shows an error  
         *
         * @param data     – the form values for business details
         * @param req      – the raw request object, including address & doingBusinessAs
         * @param callback – invoked when all async work is done (success or failure)
         */
        const handleBusinessDetailsSubmit = async (
            data: Record<string, unknown>,
            req: Record<string, any>,
            callback: () => void
        ): Promise<void> => {
            const mailingAddress = await getMailingAddress();
            const mailingAddressId = mailingAddress?.business?.mailingAddress?.[0]?.id;
            // 1. Merge new business details into our local “customer-kyc-data” blob
            const updatedBusinessState = {
                ...businessState.data,
                businessDetailsData: data,
                businessDetailsReq: req,
            };
            updateComponentData(dispatch, 'customer-kyc-data', updatedBusinessState);
            // 2. Prepare the updated formReq payload (works whether formReq was originally set or not)
            const updatedFormReq = {
                ...formReq,
                businessDetailsReq: req,
            };
            // 3. Destructure out address & DBA so we can send them separately
            const { address, ...businessReq } = req;
            // 4. Build the two API payloads

            if (mailingAddressId && businessReq.mailingAddress && businessReq.mailingAddress.length > 0) {
                const mailingAddress = [...businessReq.mailingAddress];
                mailingAddress[0] = {...mailingAddress[0],id: mailingAddressId};
                businessReq.mailingAddress = mailingAddress;
            }
            const customerPayload = {
                type: 'BUSINESS',
                isKycUpdate: true,
                business: businessReq,         // everything except address & DBA
            };
            const locationPayload = { address, doingBusinessAs: req.doingBusinessAs };
            try {
            // 5. Save the core business data
                const customerUrl = `customer/id/${getKey('customerId')}`;
                const customerResponse = await callAPI(customerUrl, Method.POST, customerPayload);
                const processedCustomer = processAPIResponse(customerResponse);
                // 6. Save the address/DBA data
                let locationResponse: any;
                if(locationDetailReq?.[0]?.id){
                    locationResponse = await httpClient.post(
                        getCustomerUrl('location/id/'+locationDetailReq?.[0]?.id, false),
                        locationPayload
                    );
                }else{
                    locationResponse = await httpClient.post(
                        getCustomerUrl('location', false),
                        locationPayload
                    );
                }
                
                const processedLocation = processAPIResponse(locationResponse);
                // 7. Combine statuses & messages
                const success = processedCustomer.status && processedLocation.status;
                const message = success
                    ? 'Data saved successfully'
                    : processedCustomer.status
                    ? processedLocation.message
                    : processedCustomer.message;
                // 8. End any loading/spinner state
                callback();
                if (success) {
                    // 9a. On success, move to the next menu and stash the updated formReq
                    updateComponentParams(dispatch, props.id, {
                    mainMenu: mainMenu + 1,
                    formReq: updatedFormReq,
                    });
                } else {
                    // 9b. On failure, alert the user
                    FxSnackBar.show({ text: message });
                }
            } catch (error) {
            // 10. Catch-all for unexpected errors
                FxSnackBar.show({ text: 'An error occurred while saving data.' });
                Logger.error(
                    'BusinessUserSignup.ts',
                    'handleBusinessDetailsSubmit',
                    error
                );
                callback(); // ensure UI resets even on exception
            }
        };

       
        /**
        * method used to handle pre-populating customer info after the deletion of beneficial owner
        */
        const handlePostBODeletionActivity = (customerBusinessData: any) => {
            const beneficialOwners = customerBusinessData?.data?.business?.beneficialOwner ?? [];

            // Convert API data to UI format
            const apiFormattedData = getBODetailsDataFromApi(beneficialOwners);

            // Merge autosaved data with latest API data
            const mergedData = mergeAutosaveWithApi(props?.autoSavedData ?? [], apiFormattedData);

            // Update component parameters with merged data
            updateComponentParams(dispatch, props?.id, { autoSavedData: mergedData });

            // Reprocess BO data only if autosaved data exists and is an array
            if (Array.isArray(props?.autoSavedData)) {
                processAllBeneficialOwners(mergedData);
            }
        };


       /**
        * method used to handle pre-populating customer info
        */
        const setInitialData = () => {
            const detailedBusinessInfo: any = context?.data?.body?.business;
            const businessCopy: any = businessState?.data ? { ...businessState.data } : {};
            let businessDetailsData: any;
            let beneficialOwnerData: any;

            // If initial user data not set, extract and validate business details
            if (!initialUserData) {
                const apiBusinessDetails = getBusinessDetailsDataFromApi(detailedBusinessInfo);
                businessDetailsData = businessState?.data?.businessDetailsData || apiBusinessDetails;

                const requiredFields = [
                'addressLine1', 'businessCategory', 'city', 'dateOfIncorporation',
                'ein', 'email', 'legalName', 'phone', 'state', 'stateOfIncorporation', 'zip'
                ];

                kycSignupFormValidator(businessDetailsData, requiredFields, 'businessDetailsSignupForm');
                businessCopy['businessDetailsData'] = businessDetailsData;
            }

            // If initial BO data not set, extract and prioritize authorized signatory
            if (!initialBOData) {
                const apiBOData = getBODetailsDataFromApi(detailedBusinessInfo?.beneficialOwner ?? []);
                beneficialOwnerData = businessState?.data?.beneficialOwnerData?.length > 0
                ? businessState?.data?.beneficialOwnerData
                : apiBOData;

                businessCopy['beneficialOwnerData'] = beneficialOwnerData;
            }

            // Fetch location details as a side effect
            getLocationDetails();

            // Update component state with processed data
            updateComponentData(dispatch, 'customer-kyc-data', businessCopy);
            updateComponentParams(dispatch, props.id, {
                initialUserData: true,
                initialBOData: true
            });
        };


        /**
         * Use Effect to call the getLocationDetails method to re-fetch the location details
         * when the mainMenu changes
         */
        useEffect(()=>{
            getLocationDetails();
        },[props?.mainMenu])

        const getLocationDetails = async () => {
            const response= await getLocationDetailData();
            const locationList: any = response?.data ?? [];
            const locationRequiredFields: Array<keyof any> = ['addressLine1','city','state','zip','doingBusinessAs'];
            const locationDetailData: any = locationList?.resources?.length > 0 ? locationList?.resources[0]?.address : {};
            locationDetailData['doingBusinessAs'] = locationList?.resources?.[0]?.doingBusinessAs;
            kycSignupFormValidator(locationDetailData,locationRequiredFields,'locationDetailsSignupCardForm');  
            updateComponentParams(dispatch,props?.id,{locationDetailReq: locationList?.resources })
            return locationList;
        }
        /**
         * Fetches the mailing address (location list) for a customer.
         *
         * Makes an HTTP GET request to the customer endpoint and returns the response data.
         *
         * @returns location list data.
         */
        const getMailingAddress = async () => {
            const locationList: any = await httpClient.get(getCustomerUrl('')).then((response) => response.data)
            return locationList;
        }

        /**
         * method used to convert the customer api response in form data format
         * @param data :data from the a[i response
         * @returns data format for form data
         */
        function getBusinessDetailsDataFromApi(data: any) {
            let _mailingAddress: any = data.mailingAddress;
            _mailingAddress = _mailingAddress ? _mailingAddress[0] : {};
            return {
                "phone": data.phone ? convertToPhoneDisplayFormat(data.phone) : '',
                "legalName": data.legalName ? data.legalName : '',
                "email": data.email ? data.email : '',
                "businessCategory": data.businessCategory ? data.businessCategory : '',
                "ein": data.ein ? data.ein : '',
                "doingBusinessAs": data.doingBusinessAs ? data.doingBusinessAs : '',
                "dateOfIncorporation": data.dateOfIncorporation ? data.dateOfIncorporation : '',
                "stateOfIncorporation": data.stateOfIncorporation ? data.stateOfIncorporation : '',
                "description":data.description ? data.description : '',
                 "website":data.website ? data.website : '',
                "addressLine1": _mailingAddress.addressLine1 ? _mailingAddress.addressLine1 : '',
                "addressLine2": _mailingAddress.addressLine2 ? _mailingAddress.addressLine2 : '',
                "city": _mailingAddress.city ? _mailingAddress.city : '',
                "state": _mailingAddress.state ? _mailingAddress.state : '',
                "zip": _mailingAddress.zip ? _mailingAddress.zip : '',
                "address_id": _mailingAddress.id ? _mailingAddress.id : '',
            }
        }

        /**
         * method used to convert customer get  api response in form data format
         * @param data :data from api response
         * @returns
         */
        function getBODetailsDataFromApi(data: any, origin?: any) {
               return data && Array.isArray(data) && data.length ? data.map((data: any) => {
                    let _mailingAddress: any = data.mailingAddress;
                    _mailingAddress = _mailingAddress ? _mailingAddress[0] : {};
                      return {
                            "id":data.id?data.id:data.id,
                            "firstName": data.firstName ? data.firstName : '',
                            "lastName": data.lastName ? data.lastName : '',
                            "email": data.email ? data.email : '',
                            "jobtitle": data.businessDetails && data.businessDetails.title ? data.businessDetails.title : '',
                            "ownerShipPercentage": data.businessDetails && data.businessDetails.ownershipPercentage && (data.businessDetails.ownershipPercentage || data.businessDetails.ownershipPercentage === 0) ? data.businessDetails.ownershipPercentage : '',
                            "dob": data.dob ? data.dob : '',
                            "ssn": data?.ssn || data?.last4ssn || '',
                            "itin": data?.taxIdentification?.id || data?.taxIdentification?.idLast4 || '', 
                            "usCitizen": data.isUSCitizen === true ? 'yes' : data.isUSCitizen === 'yes' ? 'yes' :'no',
                            "secondaryIdentificationType": data?.secondaryIdentification?.type ? data.secondaryIdentification?.type : '',
                            "description":data.description ? data.description : '',
                            "secondaryIdentificationId": data.secondaryIdentification?.id ? data.secondaryIdentification?.id : '',
                            "secondaryIdentificationIssuance":data.secondaryIdentification?.countryOfIssuance ? data.secondaryIdentification?.countryOfIssuance:'',
                            "secondaryIdentificationIssuanceAlien":data.secondaryIdentification?.secondaryIdentificationIssuanceAlien ? data.secondaryIdentification?.secondaryIdentificationIssuanceAlien:'',
                            "secondaryIdentificationIssuanceState": data.secondaryIdentification?.stateOfIssuance ? data.secondaryIdentification?.stateOfIssuance : '',
                            "address_id": _mailingAddress.id ? _mailingAddress.id : '',
                             "addressLine1": _mailingAddress.addressLine1 ? _mailingAddress.addressLine1 : '',
                            "addressLine2": _mailingAddress.addressLine2 ? _mailingAddress.addressLine2 : '',
                            "city": _mailingAddress.city ? _mailingAddress.city : '',
                            "state": _mailingAddress.state ? _mailingAddress.state : '',
                            "zip": _mailingAddress.zip ? _mailingAddress.zip : '',
                            "mobilePhone": data.mobilePhone ? origin === 'autoSavedData' ? data.mobilePhone : data.mobilePhone : '',
                            "homePhone": data.homePhone ? convertToPhoneDisplayFormat(data.homePhone) : '',
                            "workPhone": data.workPhone ? convertToPhoneDisplayFormat(data.workPhone) : '',
                            "authSignatory":data.actAsAuthorizedSignatory && data.actAsAuthorizedSignatory
                          }
                }) : []
        }

        const updateAuthSignatoryInAutosaveApi = async (index: any) => {
            let authSignReq: any = {};
            /* Loop through the 'autoSavedData' array and update the
       'actAsAuthorizedSignatory' field for each item except the one at the specified index */
        for(let i=0; i<props.autoSavedData.length;i++){
                if(i !== index)
                    authSignReq[`business.beneficialOwner[${i}].actAsAuthorizedSignatory`] = false
            }
             /* Call 'updateOnboardingFormData' with the modified 'authSignReq'
       to update the form data in the backend */
            await updateOnboardingFormData(authSignReq);  
        }


        // Method handles the onsubmit event of the beneficial owner page
        const handleBeneficialOwnerSubmit = async (data: any, req: any, action: any, index: any) => {
            let benOwnerData = [...businessState?.data?.beneficialOwnerData]
            let benOwnerReq = businessState?.data?.beneficialOwnerReq?.length > 0? [...businessState?.data?.beneficialOwnerReq]: []
            let reqArray: any;
            let dataArray: any;

            if ((req?.actAsAuthorizedSignatory === true || req?.actAsAuthorizedSignatory === 'true')) {
                const updatedBenOwnerReq = benOwnerReq.filter(item => item !== undefined).map((item: any) => {
                    return {
                      ...item,
                      actAsAuthorizedSignatory: false
                    };
                  });
                benOwnerReq = updatedBenOwnerReq;
                const updatedBenOwnerData = benOwnerData.map((item: any) => {
                    return {
                      ...item,
                      authSignatory: false
                    };
                  });
                
                benOwnerData = updatedBenOwnerData;
                await updateAuthSignatoryInAutosaveApi(index);


                if (action === 'edit' && benOwnerReq?.length > 0 && benOwnerReq[index]) {
                    benOwnerReq[index].actAsAuthorizedSignatory = true;;
                }
            }
            if (action === 'add') {
                reqArray = [...benOwnerReq, req];
                dataArray = [...benOwnerData, data];
            }
            else {
                if (index !== undefined) {
                    reqArray = [...benOwnerReq];
                    dataArray = [...benOwnerData];
                    reqArray[index] = req;
                    dataArray[index] = data;
                }
            }
            const dataCopy = {...businessState?.data}
            dataCopy['beneficialOwnerData'] = dataArray;
            dataCopy['beneficialOwnerReq'] = reqArray;
            updateComponentData(dispatch, 'customer-kyc-data', { ...dataCopy  });

            //Calls the GET autoSave API again to fetch the latest set of data
            await fetchLatestAutoSavedDetails();

        }

        /**
         * This method calls the  GET autoSave API again to fetch the latest set of data and saves the data in the autoSavedData state
         */
        const fetchLatestAutoSavedDetails = async () => {
            const previouslySavedData = await getAutosavedDataFromOnboardingFormDataApi(); //GET AUTOSAVE
            if (previouslySavedData && previouslySavedData?.data && previouslySavedData?.data?.flatFields) {
                const objectFormatData: any = unflattenObject(previouslySavedData.data.flatFields);
                const formattedData = getBODetailsDataFromApi(objectFormatData.business?.beneficialOwner, 'autoSavedData');
                updateComponentParams(dispatch, props?.id, { autoSavedData: formattedData });
            }

        }

        /**
        checking customer info is present on the customer get api or not.If data is present then calling method 'setInitialData' to prepolutae the information
         */
        
        useEffect(() => {
            if(context?.data?.body){
                setInitialData();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[context?.data?.body])

        // Method handles the onsubmit event of the review & submit page
        const handleReviewBusinessSubmit = (req: any) => {
            const businessDetailsSignupFormValid = getKey('businessDetailsSignupForm');
            const businessOwnerCardFormValid = getKey('businessOwnerCardForm')
           if( businessDetailsSignupFormValid !=='valid' || businessOwnerCardFormValid !=='valid'){
            let validFormsCopy = {...validForms}
            if(businessDetailsSignupFormValid !=='valid') validFormsCopy.businessDetailsSignupForm = false
            if(businessOwnerCardFormValid !=='valid') validFormsCopy.businessOwnerCardForm = false
            setValidForms(validFormsCopy)
            return;
           }
            const formReqCopy = {...formReq};
            formReqCopy['ReviewBusinessReq'] = req;
            updateComponentParams(dispatch, props.id, { formReq: formReqCopy })
            reviewBusinessSubmitRequest(req);
        }

        async function reviewBusinessSubmitRequest(req:any){
            let status:any = false;
            if(isUpdateContactRequest){
                status = true;
            }

            if(!status){
                status = await transformRequest(req)
            }

        }

        // Method transforms the request from various pages for api call
        async function transformRequest(accountInfo:any){

          const linkedDocuments = accountInfo?.fileData?.map((file: IFileInfo) => {
            return {
              purpose: 'AUTHORIZATION',
              document: {
                type: file?.fileType,
                name: file?.fileType === 'RATE_CARD' ? 'RATE_CARD.pdf' : 'KYC_AGREEMENT.pdf',
                base64encodedContent: file?.base64
              }
            }
          })

          let accountData: any = {
                "isCustomerOwned": true,
                "linkedDocument": linkedDocuments
            }
          if(paymentIdDetailReq?.nickname){
            accountData = {
              ...accountData,
              "nickName" : paymentIdDetailReq?.nickname
            }
          }
            let benOwnerReq = businessState?.data?.beneficialOwnerReq?.length > 0 ? [...businessState?.data?.beneficialOwnerReq] : [];
            const updatedBenOwnerReq = benOwnerReq.map((item: any) => {
                const { address_id, ...rest } = item || {};
                return rest;
              });
            benOwnerReq = updatedBenOwnerReq;
            let req:any = {
                customer:{
                    type: "BUSINESS",
                },
                account:accountData

            }
            updateComponentParams(dispatch, props.id, { isLoading: true })
            let status: any;
            
           
            req = clean(req);
            // linked documents validation
            const hasValidLinkedDocuments = (req:any) =>
                req?.account?.linkedDocument?.length > 1 &&
                req?.account?.linkedDocument[0]?.document?.base64encodedContent &&
                req?.account?.linkedDocument[1]?.document?.base64encodedContent;

              if (!hasValidLinkedDocuments(req)) {
                const data = await getLinkedDocuments(); 
                req.account=data;
              }
            status = await updateCustomer(req);
            status = processAPIResponse(status)
            if (status.status) {
                removeCookieCustom('customerKycData')
                // configuring gtm for kyc successful submit
                    const gtmData ={
                        event:"userKycSuccessTrigger",
                        "userEmail": getKey('email'),
                        "userType": "BUSINESS"
                    }

                    pushGTM(gtmData)
                    // set full story events for user kyc successful submit
                    setFullStoryEvents('userKycSuccessTrigger', {
                        "userEmail": getKey('email'),
                        "userType": "BUSINESS"
                    });
                    setKey('kycPending','true');
                        updateComponentParams(dispatch, props.id, { isLoading: false, isUpdateContactRequest: true })
                        setTimeout(() => {
                            setLocalStorage('signUpFlow',undefined);
                            history.push('/home')
                        }, 1000);


            }
            else {
                setLocalStorage('signUpFlow',undefined);
                //api  failed
                updateComponentParams(dispatch, props.id, { isLoading: false })
                let error_text =  status.message
                 if (req['customer']['business']  && req['customer']['business']['beneficialOwner'] && req['customer']['business']['beneficialOwner'][0]['actAsAuthorizedSignatory'] === "false" && req['customer']['business']['businessCategory'] === 'SOLE_PROPRIETOR') {
                    error_text = 'Authorized Signatory is required for business category Sole Proprietor'
                }
                FxSnackBar.show({
                    text: error_text,
                });

                return false;
            }

        }

    /**
     * Asynchronously generates a mock customer-owned account object
     * with two linked documents, each containing base64-encoded PDF content.
     *
     * @returns 
    *   isCustomerOwned: boolean,
    *   linkedDocument: Array<{ document: { type: string, name: string, base64encodedContent: string } }>
    */
        const getLinkedDocuments = async () => {
            const kycUrl= getKey('passportAgreementUrl');
            const rateUrl= getKey('rateCardUrl');
            const linkedDocument = [
                {
                    document: {
                        type: "PASSPORT_AGREEMENT",
                        name: "KYC_AGREEMENT.pdf",
                        base64encodedContent: await getBase64FromPDF(kycUrl),
                    },
                    purpose:"AUTHORIZATION"
                },
                {
                    document: {
                        type: "RATE_CARD",
                        name: "RATE_CARD.pdf",
                        base64encodedContent: await getBase64FromPDF(rateUrl),
                    },
                    purpose:"AUTHORIZATION"
                },
            ];

            return {
                isCustomerOwned: true,
                linkedDocument,
            };
        };
          
        /**
         * API call function
         * @param req :request
         * @returns
         */
        async function updateCustomer(req: any) {
            try {
                const data: any = await httpClient.post(getCustomerUrl('/onboard',false), req).then(response => {
                    return response
                })
                    .catch((error) => {
                        return { ...error };
                    })
                return data;
            } catch (err) {
                return err;
            }

        }

        // Method handles the click event of the beneficial owner page to move to the next screen
        const handleNextScreen = async (callback:any) => {
            let benOwnerReq = (businessState?.data?.beneficialOwnerReq?.length > 0 ? [...businessState?.data?.beneficialOwnerReq]: []);

            const updatedBenOwnerReq = benOwnerReq.filter(item => item !== undefined).map((item: any) => {
                const { address_id, secondaryIdentificationIssuanceAlien, ...rest } = item || {};
                return rest;
              });

            benOwnerReq = updatedBenOwnerReq;

            /**
             * Populate 'secondaryIdentification' if it's missing using related individual fields
             * Then remove those individual fields to keep the object clean
             */
            benOwnerReq = benOwnerReq?.map((item:any)=>{
                let secondaryIdentification:any = {}
                if(!item?.secondaryIdentification){
                    secondaryIdentification = {
                        id:item?.secondaryIdentificationId,
                        type:item?.secondaryIdentificationType,
                        countryOfIssuance:item?.secondaryIdentificationIssuance,
                        secondaryIdentificationIssuanceAlien:item?.secondaryIdentificationIssuanceAlien,
                        stateOfIssuance:item?.secondaryIdentificationIssuanceState
                    }
                    item['secondaryIdentification'] = clean(secondaryIdentification)
                    const unwantedRequestArray = ['secondaryIdentificationId', 'secondaryIdentificationType', 'secondaryIdentificationIssuance', 'secondaryIdentificationIssuanceAlien', 'secondaryIdentificationIssuanceState'];
                    deleteUnwantedRequest(item, unwantedRequestArray)
                }
                return item
            })
         /**
         *  To update beneficial owners by removing 'ssn' property for items with SSN length less than 10.
         * @param {object} req - The request object containing beneficial owner information.
         * @returns {Array} - An array of updated beneficial owners.
         */
            const updatedBeneficialOwners = (benOwnerReq || []).map((item: any) => {
                if ((item?.ssn && item.ssn.length < 10) || item.ssn === '') {
                    // Create a new object without the 'ssn' property
                    const { ssn, ...updatedItem } = item;
                    return updatedItem;
                } 

                if ((item?.itin && item.itin.length < 10) || item.itin === '') {
                    // Create a new object without the 'itin' property
                    const { itin, ...updatedItem } = item;
                    return updatedItem;
                } else if (item?.itin) {
                    // Create a new object with ITIN wrapped in taxIdentification Object
                    const { itin, ...updatedItem } = item;
                    updatedItem['taxIdentification'] = {
                        id: itin,
                        type:'ITIN'
                    }
                    return updatedItem;  
                }
                
                return item;
            });
            benOwnerReq = updatedBeneficialOwners;
            const businessDetailsReq = {
                beneficialOwner:benOwnerReq
            };
           
            const req:any = {
                type: "BUSINESS",
                isKycUpdate: true,
                business: {...businessDetailsReq}, 
            }

            const url:any="customer/id/" + getKey('customerId');
            let status = await callAPI(url, Method.POST, req)
            status = processAPIResponse(status)
            callback()
            if (status.status) {
                let mainMenuVar: number;

                    mainMenuVar = mainMenu+1;

                updateComponentParams(dispatch, props.id, { mainMenu: mainMenuVar })
            }
            else {
                //api  failed
                FxSnackBar.show({
                    text: status.message,
                });
            }          

        }
    /**
     * Handles the review process for a multi-step business signup form.
     * Validates the forms for the specified step and updates their validity status.
     * 
     * @param {number} [step] - The current step in the signup process (2, 3, or 4)
     */
    const sideBarHandleReview = async (step?: number) => {
        let currentPage: any;
        handleDataSaveOnSectionChange(step, currentPage);
        handleGoBack(step);
    };
    
    /**
     * useEffect to call the getCustomerApi when the mainMenu is 3
     */
    useEffect(()=>{
        if(props?.mainMenu === 2 && props?.fetchIds){
            callingGetCustomerApi();
        }
    },[props?.mainMenu, props?.fetchIds])


    /**
     * method used to call the get customer api
     */
    const callingGetCustomerApi = async () => {
        const customerBusinessData = await getCustomerData();
        handlePostBODeletionActivity(customerBusinessData);
    }

        // Method handles the click event to move to the previous screen
        const handleGoBack = (main: any) => {
            updateComponentParams(dispatch, props.id, { mainMenu: main });
            if(main === 2){
                getLocationDetails()
            }
        }
         // Method handles the click event to move to the previous screen for review
         const handleGoBackReview = (step?:number) => {
          if(step){
              updateComponentParams(dispatch, props.id, { mainMenu: step, fetchIds: true })
          } else {
            let mainMenu: number;
            mainMenu = 3 - 1;
            updateComponentParams(dispatch, props.id, { mainMenu, fetchIds: true })
          }
        }

      const businessData = businessState?.data?.businessDetailsData || {};
      const beneficialOwnersData = (businessState?.data?.beneficialOwnerData) || [];

      // business details for the review screen
      const basicBusinessInfo: ICardData = {
        header: 'Company Information',
        items: [{
          name: `${businessData.legalName ?? ''}`,
          data: {
            ein: {
              title: 'EIN:',
              value: businessData.ein || ''
            },
            address: {
              value: `${businessData.addressLine1 || ''} ${businessData.addressLine2 || ''}${businessData.city ? ', ' + businessData.city : ''}${businessData.state ? ', ' + businessData.state : ''}${businessData.zip ? ', Zip - ' + businessData.zip : ''}`
            },
            email: {
              value: businessData.email || ''
            }
          }
        }]
      }


      // Owner details for the review screen
      const businessOwnerData = useMemo(()=>{
        return {
            header: 'Beneficial Owner Information',
            items: beneficialOwnersData && beneficialOwnersData.length > 0 && beneficialOwnersData.map((owner: any, index: number) => {
              const ssn = getLastFourDigits(owner?.ssn || '');
              const itin = getLastFourDigits(owner?.itin || '');
                return {
                  name: `${owner?.firstName ?? ''} ${owner?.lastName ?? ''} (Ownership ${owner?.ownerShipPercentage}%)`,
                  index: index + 1,
                  data: {
                    authSignatory: {
                      value: (owner?.authSignatory === true || owner?.authSignatory === 'yes' || owner?.authSignatory === 'true')
                    },
                    email: {
                      value: owner?.email || ''
                    },
                    ...(itin ? { itin: { title: 'ITIN', value: `${itin ? '*' + itin : ''}` } } :
                    { ssn: { title: 'SSN', value: `${ssn ? '*' + ssn : ''}` } }),
                    dob: {
                      title: 'DOB',
                      value: owner?.dob || ''
                    },
                    address: {
                      value: `${owner?.addressLine1 || ''} ${owner?.addressLine2 || ''}${owner?.city ? ', ' + owner?.city : ''}${owner?.state ? ', ' + owner?.state : ''}${owner?.zip ? ', Zip - ' + owner?.zip : ''}`
                    }
    
                  }
                }
              }
            )
          }
      }, [businessState?.data?.beneficialOwnerData])


      // Review details for the review screen
      const reviewDetails = [
        { info: basicBusinessInfo, step: 1 },
        { info: businessOwnerData, step: 2 },
      ]

        /**
         * Synchronizes the “isPrimaryAddress” flag in component state whenever location details arrive.
         *
         * This effect runs whenever:
         *  - `locationDetailReq` (the array of location-detail payloads) changes, or
         *  - `businessState.data.businessDetailsData` (the form data used in the primary-address check) changes.
         *
         * What it does:
         * 1. Always marks loading as complete (`isLoading = false`).
         * 2. If there is at least one `locationDetail`, calls
         *      `checkIfPrimaryAddress(firstLocation, businessDetailsData)`
         *    to decide if it’s the primary address.
         * 3. Defaults `isPrimaryAddress` to `false` if no locations are provided.
         * 4. Batches both flags into a single `updateComponentParams` call.
         */
        useEffect(() => {
            const firstLocation = locationDetailReq?.[0] ?? null;
            const isPrimaryAddress = firstLocation ? checkIfPrimaryAddress(firstLocation, businessState?.data?.businessDetailsData) : false;
            updateComponentParams(dispatch, props.id, {isLoading: false, isPrimaryAddress});
        }, [
            // Dependencies that should trigger this effect
            locationDetailReq,
        ]);


    /**
     * Determines whether a given location item matches the business’s primary address.
     *
     * Compares street (line 1), city, state, and zip exactly (case‐insensitive, trimmed).
     * The second street line (addressLine2) is only compared if present in either source.
     *
     * @param item            – a record that may contain an `address` object
     * @param businessDetails – the business’s primary address fields
     * @returns `true` if all required fields match, otherwise `false`
     */
    function checkIfPrimaryAddress(item: { address?: any }, businessDetails:any): boolean {

        const itemAddr = item?.address ?? {};
        const bizAddr  = businessDetails ?? {};

        const equals = (a?: string, b?: string) => (a?.trim().toLowerCase() ?? '') === (b?.trim().toLowerCase() ?? '');

        for (const field of ['addressLine1', 'city', 'state', 'zip'] as const) {
            if (!equals(itemAddr[field], bizAddr[field])) {
                return false;
            }
        }

        const line2A = itemAddr.addressLine2;
        const line2B = bizAddr.addressLine2;
        if ((line2A || line2B) && !equals(line2A, line2B)) {
            return false;
        }

        return true;
    }

     /**
     *  function updates the `btnDisabled` state used to control the submit button
     *  The state is passed as a prop to a child component to enable or disable the button submit button
     * @param value 
     */
     const handleSubmitButtonDisable = (value:boolean)=>{
        setBtnDisabled(value)
     }
      return (
            <Grid id="business-user-signup-grid" item container xs={12}  className='fx-form-grid'>
                {!isSmallScreen && <Grid item xs={4} sm={6} md={4} className ="fx-login-promo-parent">
                    <BusinessLeftBarSignup goBackClick={sideBarHandleReview} activeMainMenu={mainMenu} onClick={handleMenuClick} data={businessState?.data} validateForm={validForms}></BusinessLeftBarSignup>
                </Grid>}
                {isSmallScreen && <Grid item xs={12} sm={12} md={12} className ="fx-login-promo-parent">
                    <BusinessLeftBarSignup goBackClick={sideBarHandleReview} activeMainMenu={mainMenu} onClick={handleMenuClick} data={businessState?.data}></BusinessLeftBarSignup>
                </Grid>}
                
                <Grid item xs={isSmallScreen? 12: 8} sm={isSmallScreen?12: 6} md={isSmallScreen?12: 8}>
                    {initialUserData && businessState?.data && locationDetailReq && props?.isPrimaryAddress !== undefined && <Grid className={`left-sidebar-signup ${mainMenu === 1 ? 'active' : ''}`}><BusinessDetailsSignup id="business-details-signup" data={businessState?.data?.businessDetailsData} onSubmit={handleBusinessDetailsSubmit} ref={businessDetailsSignupForm} locationData={locationDetailReq} isPrimaryAddress={props?.isPrimaryAddress}/></Grid>}
                    {initialBOData && props?.autoSavedData && <Grid className={`left-sidebar-signup ${mainMenu === 2 ? 'active' : ''}`}><BusinessOwnerCard id="business-owner-screen" businessDetails={businessState?.data?.['businessDetailsData']} updatedData={handleDeleteBOOperations} data={businessOwnerComponentData} btnDisabled={btnDisabled} setSubmitBtnDisable={handleSubmitButtonDisable} onClick={handleNextScreen} goBackClick={handleGoBack} onSubmit={handleBeneficialOwnerSubmit} ref={businessOwnerCardForm}/></Grid>}
                    {<Grid className={`left-sidebar-signup ${mainMenu === 3 ? 'active' : ''}`}><ReviewAndSubmitSignup reviewDetails={reviewDetails} goBackClick={handleGoBackReview} onSubmit={handleReviewBusinessSubmit} loading={isLoading}/></Grid>}
                </Grid>
            </Grid>
        )
    })

